import { effectiveWhatsAppTemplateCategory } from "@hightouch/lib/cep/types/whatsapp-template";

import { useWhatsAppMessageTemplate } from "src/cep/messages/use-whatsapp-message-template";
import { readTransactionalFromTemplateCategory } from "src/cep/messages/whatsapp-message-type";
import { ChannelType } from "src/types/cep";

/**
 * Whether the message's type no longer matches what its content requires,
 * the mismatch that blocks resuming it. Only WhatsApp has one today: Meta can
 * recategorize a template after approval. Undefined while the template loads.
 */
export function useMessageTypeConflict({
  message,
  enabled,
}: {
  message: {
    id: string;
    channel_type: string | null;
    transactional: boolean | null;
  };
  enabled: boolean;
}): boolean | undefined {
  const isWhatsApp = message.channel_type === ChannelType.Whatsapp;
  const { data, isLoading } = useWhatsAppMessageTemplate(message.id, {
    enabled: enabled && isWhatsApp,
    lane: "published",
  });
  if (!enabled || !isWhatsApp) return false;
  if (isLoading) return undefined;
  const expectedTransactional = readTransactionalFromTemplateCategory(
    effectiveWhatsAppTemplateCategory(data?.locale),
  );
  return (
    expectedTransactional !== null &&
    expectedTransactional !== Boolean(message.transactional)
  );
}
